var _g, _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5cb85c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 26C27 15 19 10 12 12c3 8 9 13 20 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26c5-11 13-16 20-14-3 8-9 13-20 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 27c-2-12 0-19 0-21 3 5 3 12 3 21z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24c12 0 19 9 15 22-3 10-11 16-15 16s-12-6-15-16c-4-13 3-22 15-22z",
    fill: "#e63946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62c-3 0-7-4-9-9 4 4 14 4 18 0-2 5-6 9-9 9z",
    fill: "#fdeef0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 37,
    rx: 3,
    ry: 6,
    fill: "#ff7884",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadish);
export default __webpack_public_path__ + "static/media/radish.af5077c8e94db73f1431662acd2334fe.svg";
export { ForwardRef as ReactComponent };